import {Component} from "@angular/core";

@Component({
    selector: "fhm-app-payment-account-page",
    styleUrls: ["./app-payment-account-page.component.scss"],
    templateUrl: "./app-payment-account-page.component.html",
    standalone: false
})
export class AppPaymentAccountPageComponent {

    constructor() {
    }

}
